import { logoSmallBlack } from 'assets/Icons'
import { Input, Label, Div } from './style'

interface ICheckboxProps {
  label: string
  setChecked: (_cur: any) => any
  checked?: boolean
  disabled?: boolean
  loading?: boolean
  // id?: string
}

export default function Checkbox(props: ICheckboxProps) {
  const { label, setChecked, disabled, loading } = props
  const handleCheck = (ev: any) => setChecked(ev.target.checked)

  return (
    <Div>
      {loading ? (
        <img
          className="loading-img-button"
          src={logoSmallBlack}
          alt="card icon"
        />
      ) : (
        <Input
          name="checkbox"
          type="checkbox"
          value={label}
          id={label}
          disabled={disabled}
          onChange={handleCheck}
          {...props}
        />
      )}
      <Label htmlFor={label}>{label}</Label>
    </Div>
  )
}
